/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectCostChangeCommand } from '../../models/create-project-cost-change-command';
import { CreateProjectCostChangeCommandResult } from '../../models/create-project-cost-change-command-result';

export interface ApiProjectCostChangeCreateProjectCostChangePost$Plain$Params {
      body?: CreateProjectCostChangeCommand
}

export function apiProjectCostChangeCreateProjectCostChangePost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCostChangeCreateProjectCostChangePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectCostChangeCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCostChangeCreateProjectCostChangePost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectCostChangeCommandResult>;
    })
  );
}

apiProjectCostChangeCreateProjectCostChangePost$Plain.PATH = '/api/ProjectCostChange/CreateProjectCostChange';
